module.exports = __webpack_public_path__ + "static/media/antecedentes.c6ff746b.pdf";